import { __extends } from "tslib";
import * as React from 'react';
import { Modal, ModalBody, ModalSize, ModalFooter } from '../../primitives/modal';
import { namespacedClassnames } from '../../common';
import { Button } from '../../new-libby/core/button';
export var alertModalKey = 'alert-modal';
var AlertModal = /** @class */ (function (_super) {
    __extends(AlertModal, _super);
    function AlertModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlertModal.prototype.render = function () {
        var props = this.props;
        var className = namespacedClassnames(alertModalKey, props.className);
        var isOpen = props.isOpen, body = props.body, onClose = props.onClose, closeText = props.closeText, customButtonIntent = props.customButtonIntent;
        return (React.createElement(Modal, { className: className, isOpen: isOpen, size: ModalSize.SMALL, usePortal: props.usePortal },
            React.createElement(ModalBody, null,
                React.createElement("div", { className: namespacedClassnames('body') }, body)),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { intent: customButtonIntent, className: namespacedClassnames('close'), onClick: onClose }, closeText))));
    };
    return AlertModal;
}(React.Component));
export { AlertModal };
//# sourceMappingURL=alert-modal.comp.js.map